import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 relative" data-id="element-82">
      <div className="max-w-4xl mx-auto" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-yellow-900/20 to-black border-2 border-gold/40 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-84">
          {/* Background shield watermark */}
          <ShieldCheck className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 text-gold/5 pointer-events-none" data-id="element-85" />

          <div className="relative z-10" data-id="element-86">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gold/10 mb-6" data-id="element-87">
              <ShieldCheck className="w-10 h-10 text-gold" data-id="element-88" />
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-89">
              Ironclad 30-Day Guarantee
            </h2>

            <p className="text-xl text-gray-300 leading-relaxed max-w-2xl mx-auto italic" data-id="element-90">
              "Try the system for 30 days. If you follow the steps, mail the
              letters, and your score doesn't move a single point... I will
              refund every penny of your investment. No awkward questions. You
              keep the book for your trouble. That's how confident I am that
              this works."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}